import { createSlice } from "@reduxjs/toolkit";

interface IntialStateInterface {
  loading: boolean;
  error: any;
  rowsPerPage: number;
}

const initialState: IntialStateInterface = {
  loading: false,
  error: null,
  rowsPerPage: 10,
};

const configurationCustomizeMenuSlice = createSlice({
  name: "configurationCustomizeMenu",
  initialState,
  reducers: {
    getMenuItemsStart(state) {
      state.loading = true;
      state.error = null;
    },
    getMenuItemsSuccess(state, action) {
      state.loading = false;
      state.error = null;
    },
    getMenuItemsFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    setRowsPerPage(state, action) {
      state.rowsPerPage = action.payload;
    },
    clearRowsPerPage(state) {
      state.rowsPerPage = 10;
    }
  },
});

export const { getMenuItemsStart, getMenuItemsSuccess, getMenuItemsFailure, setRowsPerPage, clearRowsPerPage } =
  configurationCustomizeMenuSlice.actions;

export default configurationCustomizeMenuSlice.reducer;
